export const LOGGED_IN_WITH_MAGIC_LINK = 'logged-in-with-magic-link'
